import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';

interface WelcomeProps {
  onNext: (data: { companyName: string; workspaceName: string }) => void;
}

export function Welcome({ onNext }: WelcomeProps) {
  const { user } = useAuth();
  const [companyName, setCompanyName] = useState('');
  const [workspaceName, setWorkspaceName] = useState('');

  function handleCompanyChange(value: string) {
    setCompanyName(value);
    // Auto-generate workspace slug
    setWorkspaceName(
      value
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .slice(0, 30)
    );
  }

  return (
    <div className="max-w-md mx-auto">
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-2xl bg-brand/10 flex items-center justify-center mx-auto mb-4">
          <svg viewBox="0 0 32 32" fill="none" className="w-8 h-8">
            <rect x="2" y="2" width="28" height="28" rx="6" fill="#6c5ce7" />
            <path d="M10 19L16 13L22 19" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 24L16 18L22 24" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
          </svg>
        </div>
        <h1 className="text-2xl font-display font-bold text-white mb-2">
          Welcome to SeedGovernance
        </h1>
        <p className="text-slate-400">
          Let's set up your compliance workspace, {user?.name?.split(' ')[0] || 'there'}.
        </p>
      </div>

      <div className="space-y-4">
        <Input
          label="Company Name"
          value={companyName}
          onChange={(e) => handleCompanyChange(e.target.value)}
          placeholder="Acme Corp"
        />
        <Input
          label="Workspace Name"
          value={workspaceName}
          onChange={(e) => setWorkspaceName(e.target.value)}
          hint="This will be your workspace URL slug"
          placeholder="acme-corp"
        />
      </div>

      <Button
        className="w-full mt-6"
        disabled={!companyName.trim() || !workspaceName.trim()}
        onClick={() => onNext({ companyName: companyName.trim(), workspaceName: workspaceName.trim() })}
      >
        Continue
      </Button>
    </div>
  );
}
